<template>
  <footer class="footer">
    <div class="content has-text-centered">
      <div class="logo">
        <figure class="image is-inline-block">
          <img
            :data-src="require('@/assets/sr-logo-50.png')"
            class="lazyload"
          />
        </figure>
      </div>
      <br />
      <p>SpeakyReads &copy; {{ year }}</p>
      <p>
        Email us at
        <span class="has-text-weight-bold">alex@speakyreads.com</span>
      </p>
      <p>
        <router-link to="/privacy-policy">Privacy Policy</router-link>
        -
        <router-link to="/terms">Terms of Service</router-link>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>

<style lang="scss" scoped></style>
